const phoneAnalytics = 'phone-analytics';

export const trackingIds = {
  routingAnalyticsCharts: `${phoneAnalytics}-routing-analytics-phoneTreeCallVolumePanel`,
} as const;
